import { ref } from 'vue';

export type ToastVariant = 'info' | 'success' | 'error' | 'warning';

export interface Toast {
    id: string;
    title?: string;
    message: string;
    variant: ToastVariant;
    duration: number;
}

const toasts = ref<Toast[]>([]);
let counter = 0;

function push(variant: ToastVariant, message: string, opts: { title?: string; duration?: number } = {}) {
    const id = `toast-${++counter}-${Date.now()}`;
    const duration = opts.duration ?? 4000;
    const toast: Toast = {
        id,
        title: opts.title,
        message,
        variant,
        duration
    };
    toasts.value = [...toasts.value, toast];
    if (duration > 0) {
        setTimeout(() => dismiss(id), duration);
    }
    return id;
}

function dismiss(id: string) {
    toasts.value = toasts.value.filter((t) => t.id !== id);
}

function clear() {
    toasts.value = [];
}

export function useToast() {
    return {
        toasts,
        dismiss,
        clear,
        info: (message: string, opts?: { title?: string; duration?: number }) => push('info', message, opts),
        success: (message: string, opts?: { title?: string; duration?: number }) => push('success', message, opts),
        error: (message: string, opts?: { title?: string; duration?: number }) => push('error', message, opts),
        warning: (message: string, opts?: { title?: string; duration?: number }) => push('warning', message, opts)
    };
}
